module.exports = __webpack_public_path__ + "img/popularize-icon-02.5c79d934.png";